<script>
  import CBrow from "./CBrow.svelte";
  import { Col, Row } from 'sveltestrap';

  import WordCloud from '../node_modules/wordcloud/src/wordcloud2.js'
  import { competences} from '../src/competences.js';
  import Saos from "./Saos.svelte";

  let emb  = ["RTOS", "FPGA", "API", "Yocto", "Serial protocols", "Drivers", "Bare metal"];
  let app  = ["Linux", "Windows", ".NET", "Qt", "C", "C++", "C#", "Python", "Bash"];
  let test = ["Unit", "Integration", "System", "Regression", "Quality", "VUnit", "NUnit", "CppUnit", "Static"];
  let pre  = ["Requirements", "Architecture", "Design", "Dev boards"];
  let cicd = ["Automation", "Deployment", "Jenkins", "Gerrit", "Docker", "GitLab", "Jira", "Reports", "DevOps"];
  let docs = ["Requirements", "Design", "Test", "Verification", "Architecture", "LaTeX", "Word"];
  let web  = ["JavaScript", "CSS", "HTML", "ASP.NET", "Svelte", "Responsive design", "Bootstrap"];

  function showWordCloud(event) {
    WordCloud(document.getElementById('my_canvas'), {
      list           : competences,
      //backgroundColor: white,
      backgroundColor: 'none',
      frontFamily    : 'Poppins',
      minRotation    : 0,
      maxRotation    : 0,
      weightFactor   : 10,
      shrinkToFit    : true,
      drawOutOfBound : false,
      wait           : 25,
      classes        : 'element',
      color          : function (word, weight) {
        if (weight >= 8) {
          return 'var(--palette-pop)';
        } else if (weight >= 5){
          return 'var(--palette-white)';
        } else {
          return 'var(--palette-grad3)';
        }
      }
    });
  }
</script>

<style>
  #canvas-container {
    overflow-y: visible;
    position: relative;
    margin-top: 60px;
    margin-bottom: 50px;
  }

  .span12 {
      width: 100%;
      height: 370px;
  }

  .canvas {
    display: block;
    position: relative;
    height: 370px;
  }

  @keyframes -global-fadein {
    from {
      opacity: 0;
    }
  }

  :global(.element) {
    animation: zoomIn .5s;
  }

  @keyframes -global-from-left {
    0% {
      transform: rotateX(50deg) translateX(-200vw) skewX(0deg);
      opacity: 1;
    }
    100% {
      transform: rotateX(0deg) translateX(0) skewX(0deg);
      opacity: 1;
    }
  }

  @-webkit-keyframes zoomIn {
    0% {
      opacity:0;
      -webkit-transform:scale3d(.3,.3,.3);
      transform:scale3d(.3,.3,.3)
    }
    50% {
      opacity:1
    }
  }

  @keyframes zoomIn {
    0% {
      opacity:0;
      -webkit-transform:scale3d(.3,.3,.3);
      transform:scale3d(.3,.3,.3)
    }
    50% {
      opacity:1
    }
  }

  .tagContainer {
    background-size: cover;
    overflow: hidden;
    position: absolute;
    width: 475px;
  }

  .shape {
    height: 300px;
    width: 460px;
    background-color: var(--palette-grad1);
    margin-left: -20px;
    position: relative;
    top: -70px;
    transform: rotate(15deg);
  }

  .tagline {
    font-size: 2rem;
    font-family: 'Dejavu Sans', sans-serif;
    float: left;
    position: relative;
    min-height: 150px;
    font-weight: 900;
    /* max-width: 450px; */
    text-align: left;
    padding-top: 25px;
    padding-bottom: 50px;
    line-height: 1;
    font-stretch: extra-condensed;
    padding-left: 25px;
  }

  .bulletList {
    font-family: Poppins;
    font-size: 20px;
    padding-left: 20px;
    padding-top: 15px;
    line-height: 1.5rem;
  }

  @media screen and (max-width:576px) {
    .tagContainer {
      width: 350px;
    }

    .shape {
      width: 325px;
    }
  }

  .text {
    color: var(--palette-white);
    text-align: left;
    font-size: 1rem;
    padding-bottom: 25px;
    padding-top: 5px;
    font-weight: 400;
  }

  .bullets {
    list-style-type: "‣ ";
    font-size: 24px;
    color: var(--palette-pop);
  }

  .button {
    display: inline-block;
    margin-top: 25px;
    padding: 5px 15px 5px 15px;
    font-size: 12px;
    transition: all 0.4s;
    background-color: var(--palette-white);
    color: var(--palette-grad2) !important;
    line-height: 18px;
    font-weight: 400;
    font-family: 'Poppins';
  }

  .button:hover {
    background-color: var(--palette-grad1);
    color: white !important;
  }

  .tags ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    padding-left: 0;
    padding-bottom: 25px;
  }

  /* .tags li + li {
    margin-right: .5rem;
  } */

  .tags li {
    color: var(--palette-pop);
    font-size: .75rem;
    height: 1.5rem;
    line-height: 1.5rem;
    letter-spacing: 1px;
    padding: 0 .5rem;
    text-align: center;
    white-space: nowrap;
    background-color: var(--palette-white);
    color: var(--palette-grad2);
    font-size: 12px;
    /* line-height: 22px; */
    margin-top: 0.5rem;
    margin-right: .5rem;
  }
</style>

<span id="whatido"></span>
<CBrow bgcolor="var(--palette-grad2-a)">
  <div slot="left">
    <div class="heading" style="color: white">What I DO</div>
    <div class="handwriting small" style="color: var(--palette-grad1)">My specifications</div>
    <a href="Micael_Axestal_CV_20210328.pdf" class="button" role="button" target="_new">DOWNLOAD RESUME →</a>
  </div>
  <div slot="right" style="width: 100%; padding-top: 25px; padding-bottom: 25px;">
    <Row>
      <Col sm="12">
        <div class="tagContainer">
          <div class="shape"></div>
        </div>
        <div class="tagline">
          CONSULTING SERVICES
          <div class="bulletList">
            <ul class="bullets">
              <li>Embedded software development</li>
                <div class="text">
                  Whether it's anything between bootloader, drivers and user space APIs, from bare metal to RTOS:es and custom Linux distributions,
                  from bit-banging serial protocols in a CPU to customized solutions in an FPGA, I have experience with them all.
                </div>
                <!-- <div class="tags">
                  <ul>
                    {#each emb as tag}
                      <li>{tag}</li>
                    {/each}
                  </ul>
                </div> -->
              <li>Application development</li>
                <div class="text">
                  Ranging from purily script-based applications in bash, Python, Ruby etc. to console and GUI-based C/C++/C# applications for both Linux and Windows.
                </div>
                <!-- <div class="tags">
                  <ul>
                    {#each app as tag}
                      <li>{tag}</li>
                    {/each}
                  </ul>
                </div> -->
              <li>Test development</li>
                <div class="text">
                  Unit, integration and system testing in a reggressive manner is key to delivering quality assured softwares. I can help
                  with both specifying and implemeting the tests as well as setting up frameworks around them to safely and easily monitor and logging
                  their results.
                </div>
                <!-- <div class="tags">
                  <ul>
                    {#each test as tag}
                      <li>{tag}</li>
                    {/each}
                  </ul>
                </div> -->
              <li>Pre-studies</li>
                <div class="text">
                  Often customers themselves needs help to gather information both from within their own organization as well as from the outside
                  of it to be able to create requirement specifications, draft design documents and system architectures before even starting the
                  development work themselves or by using external consultants.
                </div>
                <!-- <div class="tags">
                  <ul>
                    {#each pre as tag}
                      <li>{tag}</li>
                    {/each}
                  </ul>
                </div> -->
              <li>CI/CD</li>
                <div class="text">
                  Automating the building and testing as well as the deployment of every bit of code checked into a source code repository is
                  vital if you want to work in an agile manner of fast feedback and quality assured relases. For many years I have been part of
                  setting up and maintaining CI/CD-chains including tools such as Jenkins, Gerrit, Jira, GitLab and Docker.
                </div>
                <!-- <div class="tags">
                  <ul>
                    {#each cicd as tag}
                      <li>{tag}</li>
                    {/each}
                  </ul>
                </div> -->
              <li>Documentation</li>
                <div class="text">
                  Documenting a developed system and keeping it up to date is key to be able to maintain the system and to pass certain certifications
                  when it comes to for instance safety regulations. Writing requirement-, design- and test specifications as well as implementing
                  use of automated document generation through Doxygen and LaTeX has been part of my career from the beginning.
                </div>
                <!-- <div class="tags">
                  <ul>
                    {#each docs as tag}
                      <li>{tag}</li>
                    {/each}
                  </ul>
                </div> -->
              <li>Web UI development</li>
                <div class="text">
                  Yes, despite beeing an embedded developer I do have experience with web technologies as well, such as HTML, JavaScript, CSS,
                  ASP.NET, Svelte, responsive design etc (Hint: The website you're looking at for instance). Web technologies aren't limited to pure "normal" websites on the internet,
                  it's becoming increasingly popular to use when building graphical interfaces for embedded products as well due to it's
                  standardized and optimized status.
                </div>
                <!-- <div class="tags">
                  <ul>
                    {#each web as tag}
                      <li>{tag}</li>
                    {/each}
                  </ul>
                </div> -->
            </ul>
          </div>
        </div>
      </Col>
    </Row>
    <div class="tagContainer">
      <div class="shape"></div>
    </div>
    <div class="tagline">
      MAIN SKILLSET
    </div>
    <Saos once="true" top="150" on:observing={showWordCloud}></Saos>
    <div class="span12" id="canvas-container">
      <div id="my_canvas" class="canvas" style="height: 350px;"></div>
    </div>
  </div>
</CBrow>